import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {notifyTitleSet} from "./analytics/usePageViewTracking";

/**
 * 페이지 제목 설정. ` | 책잇아웃`은 여기서 붙이므로 제목만 넘길 것.
 * GA page_view는 이 제목이 정해진 뒤 보낸다 (`analytics/usePageViewTracking`).
 */
const useHtmlTitle = (title: string | null | undefined) => {
    const {pathname} = useLocation()

    useEffect(() => {
        if (title != null && title != 'undefined' && title !== '') {
            document.title = `${title} | 책잇아웃`
            notifyTitleSet(pathname)
        }
    }, [title, pathname])
}

export default useHtmlTitle
